<script setup>
  import {Link as InertiaLink} from "@inertiajs/vue3";
  import {cn} from "@pharma4u/medicheck-components/utils";

  defineOptions({name: "TabButton"});

  defineProps({
    disabled: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
    href: {
      type: String,
      default: null,
    },
  });

  const emit = defineEmits(["click"]);

  function click() {
    emit("click");
  }
</script>

<template>
  <InertiaLink
    v-if="href !== null"
    :href="href"
    :class="
      cn('inline-block rounded-t-md px-4 py-3 font-semibold hover:no-underline', {
        'border-b-2 border-mcred bg-mcred-100/50 text-mcred hover:bg-mcred-100 hover:text-mcred-700 disabled:bg-gray-200 disabled:text-gray-400':
          active,
        'bg-white text-gray-900 hover:bg-gray-100 disabled:text-gray-400': !active,
      })
    "
    :disabled="disabled"
    :data-test="getTestId('tab-inertia-link')"
  >
    <slot />
  </InertiaLink>

  <button
    v-else
    :class="
      cn('inline-block rounded-t-md px-4 py-3 font-semibold', {
        'border-b-2 border-mcred bg-mcred-100/50 text-mcred hover:bg-mcred-450 disabled:bg-gray-200 disabled:text-gray-400':
          active,
        'bg-white text-mcred hover:bg-gray-100 disabled:text-gray-400': !active,
      })
    "
    :disabled="disabled"
    :data-test="getTestId('tab-button')"
    @click="click"
  >
    <slot />
  </button>
</template>
